import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../../shared/services/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class StatusService {
  private readonly baseUrl = 'status'; // Base route for status API

  constructor(private apiService: ApiService) {}

  /**
   * Advances a document to the next status in the workflow chain
   * Automatically moves to the next sequential status based on current state
   * For user-driven status changes (JWT authenticated)
   * @param fileId - The ID of the file to advance
   * @returns Promise with advancement result message
   */
  async advanceDocumentStatus(fileId: string): Promise<{ message: string }> {
    return this.apiService.call<{ message: string }>(
      HttpMethod.PUT,
      `${this.baseUrl}/${fileId}/advance`
    );
  }

  /**
   * Reverts a document to the previous status in the workflow chain
   * Only works if document is in SEPARATION_APPROVED or later status
   * For user-driven status changes (JWT authenticated)
   * @param fileId - The ID of the file to revert
   * @returns Promise with revert result message
   */
  async revertDocumentStatus(fileId: string): Promise<{ message: string }> {
    return this.apiService.call<{ message: string }>(
      HttpMethod.PUT,
      `${this.baseUrl}/${fileId}/revert`
    );
  }
}
